import script from "./ShipCalcParamView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShipCalcParamView.vue?vue&type=script&lang=ts&setup=true"

import "./ShipCalcParamView.vue?vue&type=style&index=0&id=bdd830ba&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdd830ba"]])

export default __exports__